import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ResetPassword() {
  const { token } = useParams();
  const { setSession } = useAuth();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("La contraseña debe tener al menos 6 caracteres");
    if (password !== confirm) return toast.error("Las contraseñas no coinciden");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      setSession(data);
      toast.success("¡Contraseña actualizada!");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream-50">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl text-ink-900 font-light">Nueva contraseña</h1>
        <p className="mt-3 text-ink-500">Elige una nueva contraseña para tu cuenta.</p>

        <form onSubmit={submit} className="mt-10 space-y-6" data-testid="reset-form">
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-[0.2em] text-ink-500">Nueva contraseña</Label>
            <Input
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mínimo 6 caracteres"
              className="rounded-xl border-line focus:border-coral focus:ring-coral/20 h-12"
              data-testid="reset-password-input"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-[0.2em] text-ink-500">Confirmar contraseña</Label>
            <Input
              type="password"
              required
              minLength={6}
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Repite tu contraseña"
              className="rounded-xl border-line focus:border-coral focus:ring-coral/20 h-12"
              data-testid="reset-confirm-input"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-full bg-coral hover:bg-coral-hover text-white"
            data-testid="reset-submit-btn"
          >
            {loading ? "Guardando…" : "Guardar contraseña"}
          </Button>
        </form>

        <p className="mt-8 text-sm text-ink-500 text-center">
          <Link to="/login" className="text-coral hover:underline" data-testid="reset-back-login">
            Volver a iniciar sesión
          </Link>
        </p>
      </div>
    </div>
  );
}
